<template>
	<div style="position: absolute; left: -1000px; width: 0; height: 0">
		<share-btn ref="shareBtn" :config="conf" :shareData="shareData"></share-btn>
	</div>
</template>
<script>
import ShareBtn from 'ShareBtn/index.vue';

export default {
    name: 'ShareTemplate',
    components: {
        ShareBtn,
    },
    props: {
        shareData: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            conf: {
                shareText: '分享',
                shareTpis: '点击发送给朋友',
            },
        };
    },
};
</script>
